import React from 'react';
import { motion } from 'framer-motion';
import ImplicitNeedsCard from './ImplicitNeedsCard';
import * as FiIcons from 'react-icons/fi';

const { FiUsers, FiMessageCircle, FiAward, FiStar } = FiIcons;

const implicitNeeds = [
  {
    title: 'Belonging',
    percentage: 90,
    icon: FiUsers,
    description: 'Customers seek community connection and shared experiences',
    trend: +5
  },
  {
    title: 'Self-expression',
    percentage: 75,
    icon: FiMessageCircle,
    description: 'Users want to showcase their unique identity and values',
    trend: +3
  },
  {
    title: 'Achievement',
    percentage: 40,
    icon: FiAward,
    description: 'Desire for personal growth and milestone recognition',
    trend: -2
  },
  {
    title: 'Recognition',
    percentage: 35,
    icon: FiStar,
    description: 'Need for acknowledgment and appreciation',
    trend: +1
  }
];

const ImplicitNeedsSection = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-xl font-bold text-secondary-900">Implicit Customer Needs</h2>
          <p className="text-secondary-600">Understanding deeper emotional and psychological motivations</p>
        </div>
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="px-4 py-2 bg-primary-500 text-white rounded-lg hover:bg-primary-600 transition-colors font-medium"
        >
          View Details
        </motion.button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {implicitNeeds.map((need, index) => (
          <ImplicitNeedsCard
            key={index}
            title={need.title}
            percentage={need.percentage}
            icon={need.icon}
            description={need.description}
            trend={need.trend}
          />
        ))}
      </div>
    </div>
  );
};

export default ImplicitNeedsSection;